import { useService } from "@policoders/di";
import { BreadcrumbService, TColumn, TTableActions, TTableLineActions } from "@policoders/ds";
import { useEffect, useState } from "react";

import { CompanyForm } from "./company-form";
import { Company } from "./company.model";
import { CompanyStore } from "./company.store";

export const useCompany = () => {
  const store = useService<CompanyStore>("CompanyStore");
  const [lines, setLines] = useState<Company[]>([]);

  const breadcrumb = useService<BreadcrumbService>("BreadcrumbService");
  useEffect(() => {
    breadcrumb.set([
      { label: "Administração", value: "/administration" },
      { label: "Empresas", value: "/administration/companies" },
    ]);
  }, [breadcrumb]);

  useEffect(() => {
    store.loadList();
    var subscriber = store.state$.subscribe(state => {
      if (!state.companies) return;
      setLines(state.companies);
    });
    return () => {
      subscriber.unsubscribe();
    };
  }, [store]);

  const handleSave = async () => {
    store.save();
  };

  const handleNew = () => {
    const model = new Company();
    store.updateCurrent(model);
    store.ui.modal
      .config({
        title: "nova empresa",
        size: "large",
        buttonOkLabel: "Criar",
        buttonOkAction: handleSave,
        children: () => (
          <CompanyForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const handleEdit = (line: Company) => {
    const model = lines.find(x => x.id === line.id);
    if (!model) return;
    store.ui.modal
      .config({
        title: `editar empresa (${line.id.split("-")[0]})`,
        size: "xlarge",
        buttonOkLabel: "Salvar",
        buttonOkAction: handleSave,
        children: () => (
          <CompanyForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const handleDelete = (line: Company) => {
    if (window.confirm("excluir produto?")) store.delete(line.id);
  };

  const tActions: TTableLineActions[] = [{ label: "excluir", onClick: handleDelete }];

  const tColumns: TColumn[] = [
    { field: "name", title: "Empresa", columnClass: "d-md-table-cell" },
    { field: "email", title: "E-mail", columnClass: "d-none d-lg-table-cell" },
  ];

  const tHeaderButtons: TTableActions = {
    buttonNew: {
      label: "Nova",
      action: handleNew,
    },
  };

  return { lines, tActions, tColumns, tHeaderButtons, handleEdit };
};
